import { TaskStatus } from '../enums/TaskStatus';
import { TranslationStyleType } from '../enums/TranslationStyleType';
import Address from './Address';
import EntityBase from './EntityBase';
import File from './File';
import Language from './Language';

export type TranslationFileParseStatus = 'idle' | 'parsing' | 'parsed' | 'error';

export default class Task extends EntityBase {
    public customerId?: string;
    public taskId?: string;
    public deadLine?: string;
    public adminSeen?: boolean;
    public directedToAdmin?: boolean;
    public customerSeen?: boolean;
    public translatorSeen?: boolean;
    public originalFileCharacterCount?: number | null;
    public originalFileParseStatus?: TranslationFileParseStatus;
    public postalAddress?: Address;
    public status?: TaskStatus;
    public trackingNumber?: string;
    public include?: boolean;
    public label?: string;
    public approvedAt?: string;
    public finishedAt?: string;
    public translationStartedAt?: string;
    public style?: TranslationStyleType;
    public files?: File[];
    public explanation?: string;
    public note?: string;
    public company?: string;

    public currentBonusPercent?: number;

    public currentBonusAmount?: number;

    public currentPenaltyPercent?: number;

    public currentPenaltyAmount?: number;

    public currentDiscountPercent?: number;

    public currentDiscountAmount?: number;

    public sourceLanguages?: Language[];
    public targetLanguages?: Language[];
    public lowPages?: number
    public highPages?: number;
    public userId?: string;

    constructor(
        customerId?: string,
        postalAddress?: Address,
        status?: TaskStatus,
        trackingNumber?: string,
        include?: boolean,
        note?: string,
    ) {
        super();
        this.customerId = customerId;
        this.postalAddress = postalAddress;
        this.status = status;
        this.trackingNumber = trackingNumber;
        this.include = include;
        this.note = note;
    }
}
